<template>
  <div
    v-if="activeAnswer"
    class="unm__outer the-answer answer__stage"
  >
    <transition name="disclosure-overlay">
      <div
        v-show="showTutorial"
        class="disclosure-overlay"/>
    </transition>
    <div class="unm__container">
      <div class="answer__overlay" />
      <div class="response__image-container">
        <div class="response__image-wrapper">
          <img
            :src="activeAnswer.response.image"
            class="response__image"
            alt="">
        </div>
      </div>
      <div class="answer__container">
        <h2
          class="label label-black"
          v-text="activeAnswer.text"
        />
        <p
          class="paragraph paragraph-quiz"
          v-text="activeAnswer.response.text"
        />
        <button
          :class="{favorited: activeAnswerQuestion.saved}"
          class="favorite__button favorite__button-answer"
          @click="toggleActiveQuestionSaved"
        >
          <div
            aria-hidden="true"
            class="favorite-icon__container">
            <svg class="favorite-outline-icon">
              <use xlink:href="/images/icons/favorite-outline-icon.svg#favorite-outline-icon" />
            </svg>
            <svg class="favorite-filled-icon">
              <use xlink:href="/images/icons/favorite-filled-icon.svg#favorite-filled-icon" />
            </svg>
          </div>
          <span class="favorite__tip label label-soft">Save Tip</span>
        </button>
        <hr class="quiz__breaker">
        <button
          class="cta-small transparent-cta"
          @click="proceed"
        >Next
          <svg class="cta-small__arrow">
            <use xlink:href="/images/icons/arrow-icon.svg#arrow-icon" />
          </svg>
        </button>
      </div>
    </div>
    <transition name="disclosure">
      <div
        v-show="showTutorial"
        class="tutorial__disclosure-container">
        <div class="tutorial__disclosure-wrapper">
          <div class="tutorial__disclosure">
            <!-- eslint-disable-next-line max-len -->
            <h3 class="paragraph paragraph-splash tutorial__copy">Save any answer anytime, just hit the heart icon.</h3>
            <div class="tutorial__cta-container">
              <button
                class="action-button action-button__turquoise cta-large"
                @click="hideTutorial">
                <span class="action-button__dummy action-button__transparent cta-large">
                  <div class="action-button__shadow"/>
                </span>
                Got it
              </button>
              <button
                class="cta cta-small saved__cta"
                @click="showMenu">See what you've saved
                <svg class="cta-small__arrow saved__cta-arrow">
                  <use xlink:href="/images/icons/arrow-icon.svg#arrow-icon" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'TheAnswer',
    computed: {
      activeAnswerQuestion() {
        return this.questions.find(question => (
          question.answer === this.activeAnswer
        ));
      },
      activeAnswer() {
        if (this.quizEnded) {
          return null;
        }

        const answeredQuestions = this.questions.filter(({ answer }) => answer);

        if (!answeredQuestions.length) {
          return undefined;
        }

        return answeredQuestions.pop().answer;
      },
      ...mapState([
        'questions',
        'stage',
        'quizEnded',
        'activeQuestion',
        'showTutorial',
        'savedBefore',
      ]),
      ...mapGetters(['activeQuestionIndexString']),
    },
    activated() {
      this.setHud({
        top: 'Answer',
        bottom: `0${this.activeQuestionIndexString}`,
      });
    },
    methods: {
      showMenu() {
        this.setWillHideTutorial(true);
        this.hideTutorial();
        this.toggleMenu();
      },
      proceed() {
        if (this.savedBefore) {
          this.nextQuestion();

          return;
        }

        this.setShowTutorial(true);
      },
      ...mapMutations([
        'setHud',
        'toggleMenu',
        'hideTutorial',
        'setShowTutorial',
        'nextQuestion',
        'toggleActiveQuestionSaved',
        'setWillHideTutorial',
      ]),
    },
  };
</script>

<style lang="scss">

.answer__image {
    background-image: url("/images/graphics/white-texture.png");
    background-repeat: repeat;
}

.response__image-container {
  @include flex-grid-column(12)
  margin-top: $answer-image-margin-small;

  @include breakpoint(medium) {
    margin-top: $answer-image-margin-medium;
  }

  @include breakpoint(large) {
    @include flex-grid-column(6)
    margin-top: 0;
  }
}


.response__image-wrapper {
  position: relative;
  height: $answer-image-height-small;
  background-color: $saudia-sunset;

  @include breakpoint(medium) {
    height: $answer-image-height-medium;
  }

  @include breakpoint(large) {
    height: $answer-image-height-large;
  }
}

.response__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.answer__container {
  @include flex-grid-column(12);
  margin-top: 50px;
  text-align: left;
  padding-bottom: 100px;

  @include breakpoint(large) {
    @include flex-grid-column(5);
    @include grid-column-offset(1/24);
    display: flex;
    justify-content: center;
    margin-top: 0;
    flex-direction: column;
    padding-bottom: 0;
  }
}

.tutorial__disclosure-container {
  @include z-index(disclosure);
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  padding: 70px 0;
  background-color: rgb(0, 100, 113);
  background-image: url("/images/graphics/white-texture.png");
  background-blend-mode: multiply;
  background-size: 50px;
}

.tutorial__disclosure-wrapper {
  @include flex-grid-row;
}

.tutorial__disclosure {
  @include flex-grid-column(12);
  text-align: center;
}

.tutorial__cta-container {
  margin-top: 30px;

  @include breakpoint(large) {
    margin-top: 55px;
  }
}

.saved__cta {
  margin-top: 40px;

  @include breakpoint(medium) {
    margin-top: 0;
    margin-left: 55px;
  }
}

.disclosure-overlay {
    @include z-index(disclosure-overlay);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
}

.saved__cta {
  color: $white;
  outline: 0;
  background: none;
  transition: transform $cta-transition-duration $cta-transition-timing-function;

  &:hover,
  &:focus,
  &:active {
      @include breakpoint(large) {
        transform: scale(1.05);
      }
  }
}

.saved__cta-arrow {
  fill: $turquoise;
}

.answer__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: $answer-image-height-small;
  background-image: url("/images/graphics/red-texture.png");
  background-size: 50px;
  user-select: none;
  pointer-events: none;

  @include breakpoint(medium) {
    height: $answer-image-height-medium;
  }

  @include breakpoint(large) {
    @include flex-grid-column(4)
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .v-enter &,
  .v-leave-to & {
    @include breakpoint(large) {
      transform: translateY(-100%);
    }
  }

  .v-enter-active &,
  .v-leave-active & {

    @include breakpoint(large) {
      transition-duration: $stage-transition-duration/3;
      transition-property: all;
      transition-timing-function: $transition-timing-function;
    }
  }

  .v-leave-active & {

    @include breakpoint(large) {
      transition-delay: $stage-transition-duration/3;
    }
  }
}

.response__image-container {
  .v-enter &,
  .v-leave-to & {
    @include breakpoint(large) {
      opacity: 0;
      transform: translateX(-100%);
    }
  }

  .v-enter-active &,
  .v-leave-active & {

    @include breakpoint(large) {
      transition-duration: $stage-transition-duration/3;
      transition-property: all;
      transition-timing-function: $transition-timing-function;
    }
  }

  .v-enter-active & {

    @include breakpoint(large) {
      transition-delay: $stage-transition-duration/3;
    }
  }
}

.answer__container {
  .v-enter &,
  .v-leave-to & {
    @include breakpoint(large) {
      opacity: 0;
      transform: translateY(100%);
    }
  }

  .v-enter-active &,
  .v-leave-active & {

    @include breakpoint(large) {
      transition-duration: $stage-transition-duration/3;
      transition-property: opacity, transform;
      transition-timing-function: $transition-timing-function;
    }
  }

  .v-enter-active & {

    @include breakpoint(large) {
      transition-delay: $stage-transition-duration/3;
    }
  }
}

.the-answer {

  &.v-enter {

    @media (min-width:321px) and (max-width:1024px) {
      opacity: 0;
      transform: translateX(25%);
    }
  }

  &.v-leave-to {

    @media (min-width:321px) and (max-width:1024px) {
      opacity: 0;
      transform: translateX(-25%);
    }
  }

  &.v-enter-active,
  &.v-leave-active {

    @media (min-width:321px) and (max-width:1024px) {
      transition-duration: $stage-transition-duration/2;
      transition-property: transform, opacity;
      transition-timing-function: $transition-timing-function;
    }

    @include breakpoint(large) {
      transition-duration: $stage-transition-duration;
      transition-property: opacity, transform;
      transition-timing-function: $transition-timing-function;
    }
  }
}

.disclosure-enter-active,
.disclosure-leave-active {
  transition-duration: 150ms;
  transition-property: transform;
  transition-timing-function: $transition-timing-function;
}

.disclosure-enter-active {
    transition-delay: 150ms;
}

.disclosure-enter,
.disclosure-leave-to {
  transform: translateY(100%);
}

.disclosure-overlay-enter-active,
.disclosure-overlay-leave-active {
  transition-duration: 150ms;
  transition-property: opacity;
  transition-timing-function: $transition-timing-function;
}

.disclosure-overlay-leave-active {
    transition-delay: 150ms;
}

.disclosure-overlay-enter,
.disclosure-overlay-leave-to {
  opacity: 0;
}

.favorite__button-answer {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TheAnswer.vue